import { Routes } from '@angular/router';

import { blogArticleResolver } from './data/blog-article.resolver';
import { blogListResolver } from './data/blog-list.resolver';

/**
 * Rutas del blog, cargadas con `loadChildren` desde `app.routes.ts` y solo si
 * `environment.blogEnabled` (B58). Viven aquí, y no en `app.routes.ts`, para
 * que el resolver, `BlogService` y los mocks queden fuera del bundle inicial.
 */
export const BLOG_ROUTES: Routes = [
  {
    // El resolver pide la página, aplica el SEO del listado filtrado (B66) y
    // se re-ejecuta con cada cambio de filtros o de página.
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./blog-list-page.component').then((m) => m.BlogListPageComponent),
    resolve: { list: blogListResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    // El resolver aplica el SEO del artículo (o el `noindex` del slug
    // inexistente) y entrega la vista a la página.
    path: ':slug',
    loadComponent: () =>
      import('./blog-article-page.component').then((m) => m.BlogArticlePageComponent),
    resolve: { article: blogArticleResolver },
  },
];
